<div class="modal" tabindex="-1" role="dialog" id="messageDialog" aria-hidden="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="fs-4 fw-bold {{messageColor}}">{{message}}</div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="detailsSubscription" aria-hidden="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="mt-2 ml-2 mr-2 p-4 border rounded" style="width: 100%;max-width: 600px;">
          <h2 class="mb-4 text-center">{{detailedSubscription?.classe?.libelle}}</h2>

          <div class="row  justify-content-center">
            <div class="col-sm-5 form-group form-floating mb-3">
              <span>Frais généraux:{{detailedSubscription?.yearlyFee}}</span>
            </div>
            <div class="col-sm-5 form-group form-floating mb-3">
              <span>Frais APEC:{{detailedSubscription?.apecAmount}}</span>
            </div>
          </div>
          <div class="row  justify-content-center">
            <div class="col-sm-5 form-group form-floating mb-3">
              <span>Scolarité Octobre:{{detailedSubscription?.firstMonthAmount}}</span>
            </div>

          </div>

          <div class="row  justify-content-center">
            <div class="mb-4 text-center text-success fs-2">Rubriques complémentaires</div>
            <table class="table table-bordered table-hover table-striped text-center">
              @for (item  of detailedSubscription?.otherItems ; track item ) {
                <tr>
                  <td>{{item.libelle}}</td>
                  <td>{{item.value}}</td>
                  <td>{{item.mandatory==true?"Obligatoire":"Facultatif"}}</td>
                </tr>
              }
            </table>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="itemDialog" aria-hidden="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <form [formGroup]="itemForm" class="d-flex justify-content-center align-items-center"
          (ngSubmit)="addOtherItem()">
          <div class="mt-2 ml-2 mr-2 p-4" style="width: 100%;max-width: 600px;">
            <div class="row justify-content-center">
              <div class="form-group form-floating">
                <select  class="form-select mt-2" formControlName="idItem"
                  id="idItem" >
                  @for (item of otherItems; track item) {
                    <option value="{{item.id}}">{{item.libelle}}</option>
                  }
                </select>
                <label for="idItem">Description de la rubrique</label>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group form-floating">
                <label for="valueItem">Entrer le montant</label>
                <input type="number" class="form-control mt-2" formControlName="valueItem"
                  id="valueItem" />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group form-floating">
                <select formControlName="mandatory" class="form-select" id="mandatory">
                  <option value="" selected>Choisir propriété rubrique</option>
                  <option value="true">Obligatoire</option>
                  <option value="false">Facultatif</option>

                </select>
                <label for="mandatory">Choisir propriété rubrique</label>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="mt-2">
                <button type="submit" class="btn btn-success"
                [disabled]="!itemForm.valid">Ajouter</button>
              </div>
            </div>
          </div>

        </form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="deleteDialog" aria-hidden="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="fs-5 fw-bold">{{message}}</div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
        (click)="confirmDeleteData()">Confirmer</button>
      </div>
    </div>
  </div>
</div>
<div class="col-md-10 col-lg-11">
  @if (step=='level') {
    <div>
      <div class="row">
        <div class=" mt-3 col-md-4 col-lg-3 justify-content-start">
          @if (!isAddStep) {
            <button class="btn btn-success mb-2" (click)="displayAddStep()">Ajouter frais
            reincription</button>
          }
        </div>
      </div>
      @if (isAddStep) {
        <button class="btn btn-success mb-2 " (click)="getSchoolSubscriptionLevel()">Tableau frais
        de reinscriptions</button>
      }
      @if (isAddStep) {
        <div>
          <form [formGroup]="levelForm" class="d-flex justify-content-center align-items-center"
            (ngSubmit)="addSubscriptionLevel()">
            <input type="hidden" formControlName="idSubscription" />
            <div class="mt-2 ml-2 mr-2 p-4 border rounded" style="width: 100%;max-width: 600px;">
              <h2 class="mb-4 text-center">Informations de reinscription par cycle</h2>
              <div class="row  justify-content-center">
                <div class="col-sm-6 form-group form-floating">
                  <select formControlName="idLevel" class="ml-2 mr-2 mt-2 form-select" (change)="loadClassesByLevel()">
                    <option value="" selected>Choisir le cycle</option>
                    @for (lev of levels; track lev) {
                      <option value="{{lev.id}}">{{lev.level}}</option>
                    }
                  </select>
                  <label>Choisir le cycle</label>
                </div>
                <div class="col-sm-6 form-group form-floating">
                  <select formControlName="idClasse" class="ml-2 mr-2 mt-2 form-select">
                    <option value="" selected>Choisir la classe</option>
                    @for (cls of classes; track cls) {
                      <option value="{{cls.id}}">{{cls.libelle}} {{cls.serie}}</option>
                    }
                  </select>
                  <label for ="idClasse">Choisir la classe</label>
                </div>
              </div>
              <div class="row  justify-content-center">
                <div class="col-sm-6 form-group form-floating mb-3">
                  <label for="yearlyFee">Frais généraux</label>
                  <input type="number" class="form-control mt-2" formControlName="yearlyFee" id="yearlyFee" />
                </div>
                <div class="col-sm-6 form-group form-floating mb-3">
                  <label for="apecAmount">Frais APEC</label>
                  <input type="number" class="form-control mt-2" formControlName="apecAmount"
                    id="apecAmount" />
                </div>
              </div>
              <div class="row  justify-content-center">
                <div class="col-sm-6 form-group form-floating mb-3">
                  <label for="firstMonthAmount">Scolarité Octobre</label>
                  <input type="number" class="form-control mt-2" formControlName="firstMonthAmount"
                    id="firstMonthAmount" />
                </div>
                <div class="col-sm-6 form-group form-floating mb-3">
                  <button class="btn btn-success" type="button" (click)="openOtherItem()">+Ajouter Rubrique
                  complementaire </button>
                </div>
              </div>
              <div class="row  justify-content-center">
                <div class="mb-4 text-center text-success fs-2">Rubriques complémentaires</div>
                <table class="table table-bordered table-hover table-striped text-center">
                  @for (item  of itemsToAdd ; track $index ) {
                    <tr>
                      <td>{{item.libelle}}</td>
                      <td>{{item.value}}</td>
                      <td>{{item.mandatory==true?"Obligatoire":"Facultatif"}}</td>
                      <td>
                        <i class="fa fa-trash mr-2 ml-3" style="color: gray;" aria-hidden="false"
                        (click)="removeOtherItem(item)"></i>
                      </td>
                    </tr>
                  }
                </table>
              </div>
              <div class="mt-2 row justify-content-center">
                <div class="col-sm-6">
                  <button type="submit" class="btn btn-success rounded"
                  [disabled]="!levelForm.valid">Valider</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
      @if (!isAddStep) {
        <div id="listSubscriptionLevel"
          class="container justify-content-center d-flex align-items-center">
          <table class="table table-bordered table-hover table-striped text-center">
            <thead class="table-success">
              <tr>
                <th>Frais Annuel</th>
                <th>Scolarité Octobre</th>
                <th>APEC</th>
                <th>Classe</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (lev of subscLevel; track lev) {
                <tr>
                  <td>{{lev.yearlyFee}}</td>
                  <td>{{lev.firstMonthAmount}}</td>
                  <td>{{lev.apecAmount}}</td>
                  <td>{{lev.classe.libelle}} {{lev.classe.serie}}</td>
                  <td>
                    <i class="fa fa-edit mr-2 ml-3" style="color: green;" aria-hidden="false"
                    (click)="toUpdateStep(lev)"></i>
                    <i class="fa fa-trash mr-2 ml-2" style="color: red;" aria-hidden="false"
                    (click)="toDeleteStep(lev)"></i>
                    <i class="fa fa-list mr-2 ml-2" style="color: blue;" aria-hidden="false"
                    (click)="displayDetails(lev)"></i>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
  @if (step=='transport') {
    <div>
      <div class="row">
        <div class="mt-3 col-4 justify-content-start">
          @if (!isAddStep) {
            <button class="btn btn-success mb-2" (click)="displayAddStep()">Ajouter frais de
            transport</button>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-4 justify-content-start">
          @if (isAddStep) {
            <button class="btn btn-success mb-2 " (click)="displayListTransport()">Liste frais de
            transport</button>
          }
        </div>
      </div>
      @if (isAddStep) {
        <form [formGroup]="transportForm" class="d-flex justify-content-center align-items-center"
          (ngSubmit)="onAddTransport()">
          <div class="mt-2 ml-2 mr-2 p-4 border rounded" style="width: 100%;max-width: 600px;">
            <h2 class="mb-4 text-center">Informations d'inscription au transport</h2>
            <div class="row  justify-content-center">
              <div class="col-sm-6 form-group form-floating mb-3">
                <label for="itinerary">Itinéraire</label>
                <input type="text" class="form-control mt-2" formControlName="itinerary" id="itinerary" />
              </div>
            </div>
            <div class="row  justify-content-center">
              <div class="col-sm-6 form-group form-floating mb-3">
                <label for="subscriptionAmount">Inscription</label>
                <input type="number" class="form-control mt-2" formControlName="subscriptionAmount"
                  id="subscriptionAmount" />
              </div>
            </div>
            <div class="row  justify-content-center">
              <div class="col-sm-6 form-group form-floating mb-3">
                <label for="monthlyAmount">Mensualité</label>
                <input type="number" class="form-control mt-2" formControlName="monthlyAmount"
                  id="monthlyAmount" />
              </div>
            </div>
            <div class="mt-2 row d-flex justify-content-center">
              <div class="col-sm-6 justify-content-center">
                <button type="submit" class="btn btn-success rounded"
                [disabled]="!transportForm.valid">Valider</button>
              </div>
            </div>
          </div>
        </form>
      }
      @if (!isAddStep) {
        <div id="listSubscriptionTransport"
          class="container justify-content-center d-flex align-items-center">
          <table class="table table-bordered table-hover table-striped text-center">
            <thead class="table-success">
              <tr>
                <th>Itinéraire</th>
                <th>Montant inscription</th>
                <th>Mensualité</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (tr of transports; track tr) {
                <tr>
                  <td>{{tr.itinerary}}</td>
                  <td>{{tr.subscription}}</td>
                  <td>{{tr.monthlyAmount}}</td>
                  <td>
                    <i class="fa fa-edit mr-2 ml-3" style="color: green;" aria-hidden="false"
                    (click)="toUpdateStep(tr)"></i>
                    <i class="fa fa-trash ml-2" style="color: red;" aria-hidden="false"
                    (click)="toDeleteStep(tr)"></i>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
  @if (step=='reliquat') {
    <div>
    </div>
  }
</div>